module.exports = __webpack_public_path__ + "img/105039.8ac5abb9.png";